<template>
  <Selector :selected-option="selectedOption" :options="options" @select="select" label="filter-mode" />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { HydratedFilter } from '@/filter/types';
import { itemDefaultModes, textDefaultModes } from '@common/filter/modes';

import { find, map, propEq } from 'ramda';
import Selector from './Selector.vue';
import { Mode } from '@common/filter/types';

export default defineComponent({
  name: 'ModeSelector',
  emits: { select: null },

  components: {
    Selector,
  },

  props: {
    filter: {
      type: Object as PropType<HydratedFilter>,
      required: true,
    },

    mode: {
      type: String as PropType<Mode>,
      required: true,
    },
  },

  methods: {
    select(mode: Mode) {
      this.$emit('select', mode);
    },
  },

  computed: {
    modes(): Array<Mode> {
      if (this.filter.allowedModes) {
        return Object.keys(this.filter.allowedModes) as Array<Mode>;
      } else if (this.filter.type === 'item') {
        return itemDefaultModes;
      }

      return textDefaultModes;
    },

    options(): Array<{ label: string; value: Mode }> {
      return map((mode) => ({ label: this.$t(`filter.modes.${mode}`), value: mode }), this.modes);
    },

    selectedOption(): Mode {
      return find(propEq('value', this.mode), this.options);
    },
  },

  created() {
    if (!this.mode) this.select(this.modes[0]);
  },
});
</script>
